export const envRoot = (
  typeof process !== 'undefined' ? process.env : import.meta.env
) as Record<string, string>;
